module.exports = __webpack_public_path__ + "static/media/VETUSD.38eedc85.svg";